// extracted by mini-css-extract-plugin
module.exports = {"actionsCell":"UserFeatureLimitsDrawer_actionsCell__fo_h6","spinner":"UserFeatureLimitsDrawer_spinner__ycWyw"};